/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
/* global fetch, localStorage */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { endpoint } from '..';
import { SOLVE_PROOF_OF_ADDRESS_REQUEST, success, failure } from './action';

const events = (action$, state, { AjaxRequest }) =>
  action$
    .ofType(SOLVE_PROOF_OF_ADDRESS_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(({ id, file, type }) => {
      const formData = new FormData();

      formData.append('file', file);
      formData.append('documentType', type);

      return AjaxRequest.open('post', `/admin/pendencycustom/pendencies/${id}/proofofaddress`, formData, {
        noContentType: true,
      })('tudo')
        .flatMap((response) => Observable.of(success(response)))
        .catch((err) => Observable.of(failure(err)));
    });

export default combineEpics(events);
